import { useCallback, useRef, useState } from "react";

export function useToasts() {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(1);
  const dismiss = useCallback((id) => setToasts((items) => items.filter((item) => item.id !== id)), []);
  const notify = useCallback((title, tone = "info", message = "", duration) => {
    const id = nextId.current++;
    setToasts((items) => [...items.slice(-3), { id, title, tone, message }]);
    const timeout = Number.isFinite(Number(duration))
      ? Math.max(1000, Number(duration))
      : tone === "danger" ? 7000 : 4000;
    window.setTimeout(() => dismiss(id), timeout);
    return id;
  }, [dismiss]);
  return { toasts, notify, dismiss };
}
